export const CatAxisLeft = ( {y, innerWidth }) => (
  y.domain().map(tickValue => (
    <g key={tickValue} transform={`translate(0, ${y(tickValue)})`}>
      <line className="axis-grid" x2={innerWidth}
        style={{stroke: "#c0c0bb", opacity: 0.5}}
      />
      <text 
        className="tick-label"
        x={-3} dy=".32em" style={{textAnchor: 'end'}}>{tickValue}</text>
    </g>
  ))
);

